import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageDocsNoFilterYearContent from './PageDocsNoFilterYearContent';

function PageDocsNoFilterYear(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <PageDocsNoFilterYearContent layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <PageDocsNoFilterYearContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PageDocsNoFilterYear.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PageDocsNoFilterYear.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageDocsNoFilterYear);
